import { Controller } from "stimulus";

export default class extends Controller {
    static targets = ["input","title",'table'];
    static values = {url: String, language: String}; // Define a dynamic value for the URL

    uploadFile() {
        const file = this.inputTarget.files[0]; // Get the selected file
        const title = this.titleTarget.value; // Get the selected file
        const tableData = this.tableTarget; // Get the selected file
        if (!file) return;

        const formData = new FormData();
        formData.append("title", title);
        formData.append("file", file);
        formData.append("language", this.languageValue);

        fetch(this.urlValue, {
            method: "POST",
            body: formData
        })
            .then((response) => response.json())
            .then((data) => {
                $(tableData).append('' +
                    '<tr>' +
                    '<td>' + data.id + '</td>' +
                    '<td>' + data.title + '</td>' +
                    '<td><a target="_blank" href="' + data.fileHref + '">' + data.fileTitle + '</a></td>' +
                    '<td>' +
                    '<a data-action="click->product-files-import#deleteFile" data-delete-url="' + data.deleteUrl + '" style="cursor: pointer;" class="fa fa-trash"> Изтриване</a>' +
                    '</td>' +
                    '</tr>');
                this.titleTarget.value = '';
                this.inputTarget.value = '';
            })
            .catch((error) => console.error("Upload error:", error));
    }

    deleteFile(event){
        const el = event.currentTarget;
        var deleteUrl = el.dataset.deleteUrl;
        if (confirm("Сигурни ли сте, че искате да премахнете записа?") == true) {
            $.post(deleteUrl, function (data) {
                if (data == 'deleted') {
                    $(el).parents('tr').remove();
                }
            });
        }
    }
}
